// extracted by mini-css-extract-plugin
module.exports = {"product-image":"styles-module__product-image___3KUZr"};